module.exports = __webpack_public_path__ + "img/size_1.07b4c899.png";